// app/javascript/controllers/bike_filter_controller.js
//
// Client-side filtering for the Bikes index.
// Filters rows by search text (code/serial/customer) and status buttons.
// When locations & models are populated from DB, those filters activate automatically.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "search", "statusButton", "location", "model", "row", "count" ]

  connect () {
    this._activeStatus = "all"
    this._updateCount()
  }

  // ── Status buttons ──────────────────────────────────────────────
  filterStatus (event) {
    const btn = event.currentTarget
    this._activeStatus = btn.dataset.status

    // Update button styles
    this.statusButtonTargets.forEach(b => {
      const active = b.dataset.status === this._activeStatus
      b.classList.toggle("bg-indigo-50",     active)
      b.classList.toggle("text-indigo-800",  active)
      b.classList.toggle("ring-1",           active)
      b.classList.toggle("ring-inset",       active)
      b.classList.toggle("ring-indigo-400",  active)
      b.classList.toggle("bg-white",         !active)
      b.classList.toggle("text-gray-700",    !active)
    })

    this.filter()
  }

  // ── Search / dropdowns ──────────────────────────────────────────
  filter () {
    const query      = this._searchValue()
    const status     = this._activeStatus
    const locationId = this._locationValue()
    const modelId    = this._modelValue()

    let visible = 0

    this.rowTargets.forEach(row => {
      const match =
        this._matchesSearch(row, query) &&
        this._matchesStatus(row, status) &&
        this._matchesLocation(row, locationId) &&
        this._matchesModel(row, modelId)

      row.style.display = match ? "" : "none"
      if (match) visible++
    })

    this._updateCount(visible)

    // Show/hide empty state if target exists
    const empty = document.getElementById("bikes-empty-state")
    if (empty) {
      empty.style.display = visible === 0 && this.rowTargets.length > 0 ? "" : "none"
    }
  }

  // ── Private helpers ──────────────────────────────────────────────
  _searchValue () {
    return this.hasSearchTarget ? this.searchTarget.value.toLowerCase().trim() : ""
  }

  _locationValue () {
    return this.hasLocationTarget ? this.locationTarget.value : ""
  }

  _modelValue () {
    return this.hasModelTarget ? this.modelTarget.value : ""
  }

  _matchesSearch (row, query) {
    if (!query) return true
    return (
      (row.dataset.code     || "").includes(query) ||
      (row.dataset.serial   || "").includes(query) ||
      (row.dataset.customer || "").includes(query)
    )
  }

  _matchesStatus (row, status) {
    if (status === "all") return true
    return row.dataset.status === status
  }

  _matchesLocation (row, locationId) {
    if (!locationId) return true
    return row.dataset.locationId === locationId
  }

  _matchesModel (row, modelId) {
    if (!modelId) return true
    return row.dataset.modelId === modelId
  }

  _updateCount (n) {
    if (!this.hasCountTarget) return
    const total = n !== undefined ? n : this.rowTargets.length
    this.countTarget.textContent = total
  }
}
